import { engajamentoColor } from "../../lib/format";
import { HoverPopover } from "../ui/HoverPopover";

/** Célula de engajamento com tooltip dos 4 pilares (Progresso/Qualidade de
 * tempo/Pontualidade/Exploração) — usada em qualquer ranking (turma, escola,
 * região) que exponha os mesmos campos de EngajamentoPilares. O valor principal
 * é colorido pelo mesmo esquema (bom/atenção/crítico) já usado no engajamento
 * do aluno (perfil professor > AlunosTabela), pra dar leitura rápida do estado. */
export function EngajamentoCell({ dados }) {
  const pilares = [
    ["Progresso", dados.eng_progresso],
    ["Qualidade de tempo", dados.eng_qualidade],
    ["Pontualidade", dados.eng_pontualidade],
    ["Exploração", dados.eng_exploracao]
  ];

  return (
    <HoverPopover
      width={256}
      trigger={
        <span
          className="tnum font-bold"
          style={{ color: engajamentoColor(dados.engajamento) }}
        >
          {Math.round(dados.engajamento ?? 0)}%
        </span>
      }
    >
      <span className="block border-b border-[var(--color-brand)]/20 bg-[var(--color-brand-dim)] px-3 py-2 text-[10.5px] font-semibold uppercase tracking-wide text-[var(--color-brand-dark)]">
        Pilares do engajamento
      </span>
      <span className="grid gap-2 p-3">
        {pilares.map(([label, value]) => {
          const pct = Math.max(0, Math.min(100, Number(value) || 0));
          return (
            <span key={label} className="block">
              <span className="mb-1 flex items-baseline justify-between gap-3">
                <span className="text-[12px] text-[var(--color-ink-soft)]">
                  {label}
                </span>
                <span className="tnum text-[12px] font-semibold text-[var(--color-ink)]">
                  {Math.round(pct)}%
                </span>
              </span>
              <span className="block h-1.5 overflow-hidden rounded-full bg-[var(--color-surface-3)]">
                <span
                  className="block h-full rounded-full bg-[var(--color-data)]"
                  style={{ width: `${pct}%` }}
                />
              </span>
            </span>
          );
        })}
      </span>
    </HoverPopover>
  );
}
